import LineTelescopeIcon from 'LuxKit/Icons/line/LineTelescopeIcon'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import { rem } from 'polished'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

const BANNER_ICON = <LineTelescopeIcon size="S" />

const Banner = styled(BodyTextBlock)`
  min-height: ${rem(36)};
  padding: ${rem(8)} ${rem(12)};
  background-color: ${props => props.theme.palette.highlight.primary.normalBackground};
  color: ${props => props.theme.palette.highlight.primary.normalContrast};
`

function SearchTileFeaturedMatchBanner() {
  const intl = useIntl()

  return <Banner
    startIcon={BANNER_ICON}
    variant="medium"
    weight="bold"
  >
    {intl.formatMessage({
      id: 'QClqdJ7IxKd-ZSIe_aPh',
      defaultMessage: 'Featured match · based on your search',
      description: 'Banner text shown above the main metasearch property tile when it matches the user search intent',
    })}
  </Banner>
}

export default SearchTileFeaturedMatchBanner
